// src/providers/app-providers.tsx
"use client"

import { ReactNode } from "react"
import { TooltipProvider } from "@/components/ui/tooltip"
import { QueryProvider } from "@/lib/query-client"
import { ThemeProvider } from "@/providers/theme-provider"
import { Toaster } from "@/components/ui/sonner"

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem
      disableTransitionOnChange
    >
      <TooltipProvider delayDuration={0}>
        <QueryProvider>{children}</QueryProvider>
        <Toaster richColors closeButton />
      </TooltipProvider>
    </ThemeProvider>
  )
}
